/**
 * Ett fåtal funktioner från npm-paketet 'dom-helpers'.
 *
 * Funktionerna är flyttade hit för att kunna göra rcc-bootstrap till ett esm-paket.
 */ export const getScrollbarSize = function() {
    let size;
    return (recalc)=>{
        if (size === undefined || recalc) {
            const scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
        return size;
    };
}();
const rUpper = /([A-Z])/g;
function hyphenate(string) {
    return string.replace(rUpper, '-$1').toLowerCase();
}
export function css(node, property) {
    return node.style.getPropertyValue(hyphenate(property)) || getComputedStyle(node).getPropertyValue(hyphenate(property));
}
function parseDuration(node) {
    const str = css(node, 'transitionDuration') || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function triggerEvent(node, eventName, bubbles = false, cancelable = true) {
    if (node) {
        const event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}
function listen(node, eventName, handler, options) {
    node.addEventListener(eventName, handler, options);
    return ()=>{
        node.removeEventListener(eventName, handler, options);
    };
}
function emulateTransitionEnd(element, duration, padding = 5) {
    let called = false;
    const handle = setTimeout(()=>{
        if (!called) {
            triggerEvent(element, 'transitionend', true);
        }
    }, duration + padding);
    const remove = listen(element, 'transitionend', ()=>{
        called = true;
    }, {
        once: true
    });
    return ()=>{
        clearTimeout(handle);
        remove();
    };
}
export function transitionEnd(element, handler, duration, padding) {
    let dur = duration;
    if (typeof dur !== 'number') {
        dur = parseDuration(element) || 0;
    }
    const removeEmulate = emulateTransitionEnd(element, dur, padding);
    const remove = listen(element, 'transitionend', handler);
    return ()=>{
        removeEmulate();
        remove();
    };
}
